const state = {
    collectDataSubTitle: "",
    taxFilingData: {
        taxFilingDataId: "",
        businessOperatorCode: "",
        businessOperatorName: "",
        businessOperatorType: "",
    }
}

const getters = {

}

const mutations = {

    updateCollectDataSubTitle(state, collectDataSubTitle) {
        state.collectDataSubTitle = collectDataSubTitle
    },

    updateTaxFilingData(state, taxFilingData) {
        state.taxFilingData = taxFilingData
    }
}

const actions = {
    commitCollectDataSubTitle({ commit }, data) {
        commit('updateCollectDataSubTitle', data);
    },
    commitTaxFilingData({ commit }, data) {
        commit('updateTaxFilingData', data);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}